var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "plant-item-risk-details-modal",
        "data-toggle": "modal",
        tabindex: "-1",
        role: "dialog",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg modal-dialog-centered",
          staticStyle: { "max-width": "1200px" },
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("riskModalTitle")) + " "),
              ]),
              _vm._m(0),
            ]),
            _c("div", { staticClass: "modal-body pt-3" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _c(
                    "table",
                    { staticClass: "table table-sm table-bordered" },
                    [
                      _c("tr", [
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("riskId")) + " "),
                        ]),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("riskTitle")) + " "),
                        ]),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("riskStatus")) + " "),
                        ]),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("riskMirr")) + " "),
                        ]),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("riskStrategyCost")) +
                              " (K" +
                              _vm._s(_vm.getCurrencySymbol()) +
                              ") "
                          ),
                        ]),
                        _c("th", { attrs: { colspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("riskCost")) + " "),
                        ]),
                        _c("th", { attrs: { colspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("riskSafety")) + " "),
                        ]),
                        _c("th", { attrs: { colspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("riskEnvironment")) + " "),
                        ]),
                        _c("th", { attrs: { colspan: "2" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("riskRegulatory")) + " "),
                        ]),
                        _c("th", { attrs: { colspan: "2" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("riskReputational")) + " "
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.$t("riskBefore")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("riskAfter")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("riskBefore")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("riskAfter")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("riskBefore")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("riskAfter")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("riskBefore")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("riskAfter")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("riskBefore")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("riskAfter")))]),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v(_vm._s(_vm.risk.riskId))]),
                        _c("td", [_vm._v(_vm._s(_vm.risk.riskTitle))]),
                        _c("td", [_vm._v(_vm._s(_vm.risk.riskStatus))]),
                        _c("td", [_vm._v(_vm._s(_vm.risk.mitigatedIRR))]),
                        _c("td", [
                          _vm._v(
                            "K" +
                              _vm._s(_vm.getCurrencySymbol()) +
                              " " +
                              _vm._s(
                                _vm._f("formatRiskCostValue")(
                                  _vm.risk.strategyCost
                                )
                              )
                          ),
                        ]),
                        _c(
                          "td",
                          { class: _vm.getCostColor(_vm.risk.costScoreBefore) },
                          [_vm._v(" " + _vm._s(_vm.risk.costScoreBefore) + " ")]
                        ),
                        _c(
                          "td",
                          { class: _vm.getCostColor(_vm.risk.costScoreAfter) },
                          [_vm._v(" " + _vm._s(_vm.risk.costScoreAfter) + " ")]
                        ),
                        _c(
                          "td",
                          {
                            class: _vm.getSafetyColor(
                              _vm.risk.safetyScoreBefore
                            ),
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.risk.safetyScoreBefore) + " "
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            class: _vm.getSafetyColor(
                              _vm.risk.safetyScoreAfter
                            ),
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.risk.safetyScoreAfter) + " "
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            class: _vm.getEnvironmentColor(
                              _vm.risk.environmentScoreBefore
                            ),
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.risk.environmentScoreBefore) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            class: _vm.getEnvironmentColor(
                              _vm.risk.environmentScoreAfter
                            ),
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.risk.environmentScoreAfter) + " "
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            class: _vm.getRegulatoryColor(
                              _vm.risk.regulatoryScoreBefore
                            ),
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.risk.regulatoryScoreBefore) + " "
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            class: _vm.getRegulatoryColor(
                              _vm.risk.regulatoryScoreAfter
                            ),
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.risk.regulatoryScoreAfter) + " "
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            class: _vm.getReputationalColor(
                              _vm.risk.reputationalScoreBefore
                            ),
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.risk.reputationalScoreBefore) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            class: _vm.getReputationalColor(
                              _vm.risk.reputationalScoreAfter
                            ),
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.risk.reputationalScoreAfter) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [_c("span", [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }